import { render, staticRenderFns } from "./SaleOrganTree.vue?vue&type=template&id=0fd85ffc&"
import script from "./SaleOrganTree.vue?vue&type=script&lang=js&"
export * from "./SaleOrganTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports